import InputAdornment from "@mui/material/InputAdornment";
import { Button, FlexColumn, GridRow, LocaleNumberField, SingleSelect } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { ComponentItem } from "designSystem/types/component-item-types";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { CompositionType } from "./CompositionStore";

interface TypeVariantSectionProps {
	index: number;
	isSingleComposition: boolean;
	item: CompositionType;
	items: ComponentItem[];
	removeTypeVariant: (index: number) => void;
}

export const TypeVariantSection:  FunctionComponent<TypeVariantSectionProps> = observer(function TypeVariantSection(props) {
	const {
		index,
		isSingleComposition,
		item,
		items,
		removeTypeVariant,
	} = props;

	const {
		compositionTypePercentageIsInvalid,
		currentValue,
		percentageFixed,
		setCompositionTypeUrl,
		setCompositionTypePercentage,
	} = item;

	const loc = useLocale();

	function handleDelete() {
		removeTypeVariant(index);
	}

	const isSingleTypeVariant = items.length === 1;

	return (
		<FlexColumn gap={3}>
			<SingleSelect
				disableClearable
				disabled={isSingleTypeVariant}
				onChange={setCompositionTypeUrl}
				options={items}
				value={currentValue}
			/>
			<GridRow
				alignItems="center"
				justifyContent="space-between" 
			>
				<LocaleNumberField
					InputProps={{
						endAdornment:
							<InputAdornment position="end">
								{loc.resource("PercentageSign")}
							</InputAdornment>,
					}}
					defaultValue={percentageFixed}
					error={compositionTypePercentageIsInvalid}
					onChange={setCompositionTypePercentage}
					placeholderRes="FormatDoublePercentage"
					required
					selectOnFocus
				/>
				{isSingleComposition ? null : (
					<Button 
						design="link" 
						onClick={handleDelete} 
						res="Delete"
					/>
				)}
			</GridRow>
		</FlexColumn>
	);
});